/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { FUNDING_CASH, FUNDING_LOAN } from '../../enums/FundingMethodCodes.mjs'

export type FundingMethodLabelProps = {
  value: FundingMethod
}

function FundingMethodLabel (props: FundingMethodLabelProps) {
  const { value } = props
  const intl = useIntl()

  if (value === FUNDING_CASH) {
    return intl.formatMessage({
      id: 'cash',
      defaultMessage: 'Comptant'
    })
  }
  if (value === FUNDING_LOAN) {
    return intl.formatMessage({
      id: 'loan',
      defaultMessage: 'Prêt bancaire'
    })
  }
  return null
}

export default FundingMethodLabel
